export default __webpack_public_path__ + "images/630ced3f6cee99985b10f4c955b13520-aetheism_small.webp";